import FJHairstyleChangerLeftContainer from './FJHairstyleChangerLeft/container/FJHairstyleChangerLeftContainer.jsx';
import FJHairstyleChangerRightContainer from './FJHairstyleChangerRight/container/FJHairstyleChangerRightContainer.jsx';

const FJHairstyleChanger = () => {
    return (
        <>
            <FJHairstyleChangerLeftContainer />
            <FJHairstyleChangerRightContainer />
        </>
    );
};

export default FJHairstyleChanger;
